import { composeInitialState } from '@opengov/compose-app';

import { composeStateMachine } from '../module';

import { IContextMenuAlignment, IContextMenuInitialState } from './types';

const initialState: IContextMenuInitialState = {
  componentType: 'exampleContextMenu',
  targetElementLocationData: null,
  contextMenuDimensions: null,
  contextMenuAlignment: 'AUTO'
};

export const contextMenuInitialState = composeInitialState(initialState);

export const contextMenuState = composeStateMachine('CONTEXT_MENU', contextMenuInitialState, compose => ({
  setContextMenuData: compose.action(
    (state, payload: { componentType: string; targetElementLocationData: DOMRect }) =>
      state
        .set('componentType', payload.componentType)
        .set('targetElementLocationData', payload.targetElementLocationData)
  ),
  setContextMenuDimensions: compose.action((state, contextMenuDimensions: DOMRect) =>
    state.set('contextMenuDimensions', contextMenuDimensions)
  ),
  setContextMenuAlignment: compose.action((state, contextMenuAlignment: IContextMenuAlignment) =>
    state.set('contextMenuAlignment', contextMenuAlignment)
  ),
  resetContextMenuState: compose.payloadlessAction(state =>
    state
      .set('componentType', '')
      .set('targetElementLocationData', null)
      .set('contextMenuDimensions', null)
      .set('contextMenuAlignment', null)
  )
}));

export const {
  actions: contextMenuActions,
  actionCreators: contextMenuActionCreators,
  reducer: contextMenuReducer,
  selector: contextMenuSelector
} = contextMenuState;
